module.exports = __webpack_public_path__ + "static/media/ta.63a0fa9d.svg";